import { fetchApi } from '../lib/apiClient';
import { Tag, CreateTagData, UpdateTagData, TaskTag } from '../types/tag';

export class TagService {
  /**
   * 获取用户的所有标签
   */
  static async fetchTags(): Promise<Tag[]> {
    try {
      return await fetchApi<Tag[]>('/tags/list', { method: 'GET' });
    } catch (error) {
      console.error('获取标签列表失败:', error);
      throw error;
    }
  }

  /**
   * 创建新标签
   */
  static async createTag(tagData: CreateTagData): Promise<Tag> {
    try {
      return await fetchApi<Tag>('/tags/create', {
        method: 'POST',
        body: tagData,
      });
    } catch (error) {
      console.error('创建标签失败:', error);
      throw error;
    }
  }

  /**
   * 更新标签
   */
  static async updateTag(tagData: UpdateTagData): Promise<Tag> {
    try {
      return await fetchApi<Tag>('/tags/update', {
        method: 'POST',
        body: tagData,
      });
    } catch (error) {
      console.error('更新标签失败:', error);
      throw error;
    }
  }

  /**
   * 删除标签
   */
  static async deleteTag(tagId: string): Promise<{ success: boolean }> {
    try {
      return await fetchApi<{ success: boolean }>(`/tags/delete?id=${tagId}`, {
        method: 'DELETE',
      });
    } catch (error) {
      console.error('删除标签失败:', error);
      throw error;
    }
  }

  /**
   * 为任务添加标签
   */
  static async addTagToTask(taskId: string, tagId: string): Promise<any> {
    try {
      return await fetchApi('/tags/add-to-task', {
        method: 'POST',
        body: { taskId, tagId },
      });
    } catch (error) {
      console.error('为任务添加标签失败:', error);
      throw error;
    }
  }

  /**
   * 从任务移除标签
   */
  static async removeTagFromTask(taskId: string, tagId: string): Promise<{ success: boolean }> {
    try {
      return await fetchApi<{ success: boolean }>('/tags/remove-from-task', {
        method: 'POST',
        body: { taskId, tagId },
      });
    } catch (error) {
      console.error('从任务移除标签失败:', error);
      throw error;
    }
  }

  /**
   * 获取任务的所有标签
   */
  static async getTaskTags(taskId: string): Promise<TaskTag[]> {
    try {
      return await fetchApi<TaskTag[]>(`/tags/list-task-tags?taskId=${taskId}`, {
        method: 'GET',
      });
    } catch (error) {
      console.error('获取任务标签失败:', error);
      throw error;
    }
  }
}